import { SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";
import React from "react";

export const MSTableColumnSettingModalContentSkeleton = () => {
  const { palette } = useTheme();

  return (
    <SHStack gap={2}>
      {Array.from({ length: 12 }).map((_, i) => (
        <SHStack
          key={i}
          direction={"row"}
          width={"100%"}
          height={50}
          bgcolor={palette.common.whitesmoke}
          borderRadius={"4px"}
          alignContent={"center"}
          alignItems={"center"}
          justifyContent={"space-between"}
          paddingLeft={2}
        >
          <SHStack direction={"row"} alignItems={"center"} gap={1.5}>
            <SHSkeleton delay={false} width={22} height={22} variant={"circular"} />
            <SHSkeleton delay={false} width={22} height={22} />
            <SHSkeleton delay={false} width={200} height={22} />
          </SHStack>

          <SHStack marginRight={1}>
            <SHSkeleton delay={false} width={22} height={22} />
          </SHStack>
        </SHStack>
      ))}
    </SHStack>
  );
};
